module.exports = __webpack_public_path__ + "img/5.ba467527.jpg";